export default __webpack_public_path__ + "static/media/unread.4a5a99b7.svg";